export default __webpack_public_path__ + "static/media/trade.37188958.png";